import { AnalyticsMetaKeys as key } from '../../../../../services/analytics/formatters/meta-keys'
import { IdentityEvent } from '../../../../../services/common/events/identity'
import { AnalyticsEvent } from '../../../event'
import { GlobalDataFormatter } from '../formatters/global-data'
import { PageEvents } from '../page-events'

const mParticleEvents: PageEvents = new PageEvents()

export class Default extends AnalyticsEvent {

    /**
     * Handle event
     */
    public handle(): void {

        /**
         * Event Handler: creat Attributes list and send it to mParticle
         * @var attrs will be different for each events
         *
         */
        // Get attributes list
        const dataAttrs = this.getAttributesList()

        // Get Data Values
        const globalFormatter = new GlobalDataFormatter(this.metaProperties)
        let data: any = {}
        dataAttrs.forEach((attr) => {
            try {
                const attrValue = globalFormatter.lookup(attr)
                if(attrValue !== '') {
                    data[attr] = attrValue
                }
            } catch(e) {
                console.error('GlobalDataFormatter error', e)
            }
        })
        // Add custom element data to Event Data
        data = {...data, ...this.getCustomElementData()}
        this.eventData = this.eventData || this.getProperties()
        const controlFields = this.getControlFields()
        const mpCustomFlag: {} = controlFields.ga_non_interaction? {'Google.NonInteraction': true}:{}
        if(controlFields && controlFields.mp_native_event) {
            // check if mParticle supported native action include the current action
            if (PageEvents.mpSupportedNativeAction.includes(this.action)) {

                addEventListener(IdentityEvent.MP_READY, (e: any) => {
                    if (e.detail.mpSessionUuid) {
                        data = {
                            ...data,
                            ...{[key.SESSION_UUID]: String(e.detail.mpSessionUuid)},
                            ...{[key.MP_ID]: String(e.detail.mpId)}
                        }
                    }
                    mParticleEvents.logPageView(
                        this.type || PageEvents.mpEventName.ScreenView,
                        data,
                        mpCustomFlag
                    )
                })
            } else {
                // Send error event to mParticle
                mParticleEvents.logCustomError('mParticleEvents not Supported',this.type)
                console.error('mParticleEvents not Supported',this.type,'Action',this.action)
            }

        } else {
            // Send custom event to mParticle
            const mpEventType: string = controlFields.mp_event_type || 'Other'
            mParticleEvents.logEvent(
                this.type, // Change Event Name
                PageEvents.mpEventType[mpEventType],
                data,
                mpCustomFlag
                )
        }
    }
}
